<template>
  <div class="premium-event-page">
    <!-- Ultra-Clean Back Navigation -->
    <v-btn elevation="0" class="custom-back-btn" @click="$router.push('/')" fab small>
      <v-icon color="black">mdi-chevron-left</v-icon>
    </v-btn>

    <!-- Hero Showcase Segment -->
    <v-img class="hero-viewport" height="95vh" src="https://app.wellcomefit.ch/img/einmalig/alibey/slider/alibeySlider6.jpg" cover>
      <div class="hero-overlay d-flex flex-column justify-center align-center">
        <!-- Floating Glass Control Center -->
        <div class="glass-hero-card text-center animate-blur-in">
          <v-img
            class="mx-auto mb-6"
            contain
            max-height="65px"
            src="https://app.wellcomefit.ch/img/logos/studio/WELL-COME-FIT_LOGO_BLACK.png"></v-img>

          <span class="location-tag white--text">EXCLUSIVE CLUB RESORT</span>
          <h2 class="main-event-title">Ali Bey Club Manavgat, Antalya</h2>
          <div class="premium-date-wrapper">
            <v-icon small color="white" class="mr-2">mdi-calendar-gold</v-icon>
            <span>29. MAI 2027 – 05. JUNI 2027</span>
          </div>

          <p class="hero-teaser-text">
            Sonne, Meer und ganz viel Fitness! Der Mix aus Sport, Gesundheit, Party und Erholung macht dieses Event zu einem unvergleichlichen
            Erlebnis für Dich, Deine Freunde und Deine Familie!
          </p>

          <v-btn class="cta-pulse-button" color="white" light large rounded elevation="12" @click="pushToBookingPage">
            <span class="black--text font-weight-black">JETZT PLATZ SICHERN</span>
            <v-icon right color="black" class="ml-2">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-img>

    <!-- Main Content Stream -->
    <div class="luxury-body-wrapper" ref="contentSection">
      <!-- Bento Grid Features Section -->
      <div class="luxury-card-section">
        <div class="section-header-block text-center">
          <span class="section-pre-title">ALL-INCLUSIVE HIGHLIGHTS</span>
          <h3 class="section-main-title">Das ist alles für dich drin</h3>
          <div class="luxury-accent-line"></div>
        </div>

        <v-container fluid class="pa-0 mt-8">
          <v-row class="nested-bento-grid">
            <v-col cols="12" sm="6" md="4" v-for="(feature, i) in features" :key="i" class="pa-3">
              <div class="bento-card text-card animate-blur-in">
                <div class="bento-icon-wrapper">
                  <v-icon color="primary" class="bento-icon">{{ feature.icon }}</v-icon>
                </div>
                <div class="bento-content">
                  <h4>{{ feature.text }}</h4>
                  <p class="bento-subtext">Exklusiver Zugang & Premium-Qualität vor Ort inklusive.</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Core Pillars / Advantages Section -->
      <div class="luxury-card-section alternative-bg">
        <div class="section-header-block text-center mb-8">
          <span class="section-pre-title">DEINE PRIVILEGIEN</span>
          <h3 class="section-main-title">Unschlagbare Vorteile vor Ort</h3>
          <div class="luxury-accent-line"></div>
        </div>

        <div class="premium-pillars-layout">
          <div class="pillar-item">
            <div class="pillar-status-ring"><v-icon color="primary">mdi-shield-star</v-icon></div>
            <h4>Coaching & Beratung</h4>
            <p>Individuelle Trainings- & Ernährungsberatung durch unsere Experten.</p>
          </div>
          <div class="pillar-item">
            <div class="pillar-status-ring"><v-icon color="primary">mdi-account-group</v-icon></div>
            <h4>Trainer-Netzwerk</h4>
            <p>Exklusives Trainer-Netzwerk für dich vor Ort.</p>
          </div>
          <div class="pillar-item">
            <div class="pillar-status-ring"><v-icon color="primary">mdi-fire</v-icon></div>
            <h4>Community Power</h4>
            <p>Einzigartige sportliche Community vor Ort erleben.</p>
          </div>
        </div>
      </div>

      <!-- Flight recommendations Section (v-if="false") -->
      <div v-if="false" class="luxury-card-section">
        <div class="section-header-block text-center mb-8">
          <span class="section-pre-title">REISEPLANUNG</span>
          <h3 class="section-main-title">Flugempfehlungen ab Zürich</h3>
          <div class="luxury-accent-line"></div>
        </div>

        <div class="travel-timeline-container animate-blur-in">
          <v-row>
            <!-- Hinflüge -->
            <v-col cols="12" md="6">
              <div class="luxury-flight-card outbound">
                <div class="flight-card-header">
                  <span class="flight-direction-badge"
                    ><v-icon small class="mr-1" color="primary">mdi-airplane-takeoff</v-icon> HINFLÜGE – 30.05.2026</span
                  >
                </div>

                <div class="flight-routes">
                  <div class="flight-route-item" @click="openSunExpress">
                    <div class="airline-logo-box">
                      <v-icon color="orange darken-2" size="24">mdi-airplane</v-icon>
                      <div class="airline-meta">
                        <span class="airline-name font-weight-bold">SunExpress</span>
                        <span class="flight-number">Direktflug | ZRH</span>
                      </div>
                    </div>
                    <div class="route-timeline">
                      <div class="airport-node">
                        <span class="node-time">09:40</span>
                        <span class="node-code">ZRH</span>
                      </div>
                    </div>
                    <v-icon class="external-icon" small color="grey">mdi-open-in-new</v-icon>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="flight-route-item" @click="openEdelweiss">
                    <div class="airline-logo-box">
                      <v-icon color="red lighten-1" size="24">mdi-airplane</v-icon>
                      <div class="airline-meta">
                        <span class="airline-name font-weight-bold">Edelweiss</span>
                        <span class="flight-number">Direktflug | ZRH</span>
                      </div>
                    </div>
                    <div class="route-timeline">
                      <div class="airport-node">
                        <span class="node-time">05:45</span>
                        <span class="node-code">ZRH</span>
                      </div>
                    </div>
                    <v-icon class="external-icon" small color="grey">mdi-open-in-new</v-icon>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Rückflüge -->
            <v-col cols="12" md="6">
              <div class="luxury-flight-card inbound">
                <div class="flight-card-header">
                  <span class="flight-direction-badge"
                    ><v-icon small class="mr-1" color="grey">mdi-airplane-landing</v-icon> RÜCKFLÜGE – 06.06.2026</span
                  >
                </div>

                <div class="flight-routes">
                  <div class="flight-route-item" @click="openSunExpress">
                    <div class="airline-logo-box">
                      <v-icon color="orange darken-2" size="24">mdi-airplane</v-icon>
                      <div class="airline-meta">
                        <span class="airline-name font-weight-bold">SunExpress</span>
                        <span class="flight-number">XQ | AYT</span>
                      </div>
                    </div>
                    <div class="route-timeline">
                      <div class="airport-node">
                        <span class="node-time">06:10</span>
                        <span class="node-code">AYT</span>
                      </div>
                    </div>
                    <v-icon class="external-icon" small color="grey">mdi-open-in-new</v-icon>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="flight-route-item" @click="openSunExpress">
                    <div class="airline-logo-box">
                      <v-icon color="orange darken-2" size="24">mdi-airplane</v-icon>
                      <div class="airline-meta">
                        <span class="airline-name font-weight-bold">SunExpress</span>
                        <span class="flight-number">XQ | AYT</span>
                      </div>
                    </div>
                    <div class="route-timeline">
                      <div class="airport-node">
                        <span class="node-time">14:55</span>
                        <span class="node-code">AYT</span>
                      </div>
                    </div>
                    <v-icon class="external-icon" small color="grey">mdi-open-in-new</v-icon>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="flight-route-item" @click="openEdelweiss">
                    <div class="airline-logo-box">
                      <v-icon color="red lighten-1" size="24">mdi-airplane</v-icon>
                      <div class="airline-meta">
                        <span class="airline-name font-weight-bold">Edelweiss</span>
                        <span class="flight-number">WK | ZRH</span>
                      </div>
                    </div>
                    <div class="route-timeline">
                      <div class="airport-node">
                        <span class="node-time">10:55</span>
                        <span class="node-code">AYT</span>
                      </div>
                    </div>
                    <v-icon class="external-icon" small color="grey">mdi-open-in-new</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Luxury Panel Accordion -->
      <div class="luxury-card-section alternative-bg">
        <div class="section-header-block text-center mb-6">
          <span class="section-pre-title">TRANSPARENZ</span>
          <h3 class="section-main-title">🍹 Ultra All-Inclusive Aufschlüsselung</h3>
          <div class="luxury-accent-line"></div>
        </div>

        <v-expansion-panels class="boutique-panels" flat mandatory value="0">
          <v-expansion-panel class="boutique-panel-item">
            <v-expansion-panel-header class="boutique-panel-trigger">
              <v-icon left color="success" class="mr-2">mdi-check-circle-outline</v-icon>
              <strong>Komplett ohne Aufpreis inklusive (Ohne Gebühr)</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="boutique-panel-body">
              Minibar, 24h Markeneiscreme, alle Softdrinks, frische Säfte, Sekt, Energy Drinks, Cocktails, Import-Alkohol (z.B. Chivas, Absolut,
              Havana), Türkischer Kaffee & Hammam, WLAN, Aquapark, Beach Volleyball u.v.m.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="boutique-panel-item">
            <v-expansion-panel-header class="boutique-panel-trigger">
              <v-icon left color="amber" class="mr-2">mdi-credit-card-plus-outline</v-icon>
              <strong>Optionale Leistungen (Gegen Gebühr)</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="boutique-panel-body">
              Premiumgetränke, diverse Weinsorten, Tennisplätze und Kurse, Padel-Tennisplätze, Tennisausrüstung, Billard, Arcade-Spiele, Massage,
              VIP-Hammam, Arzt, Geschäfte, Wäsche Service, Friseur, Fotograf, Kinderwagenverleih, Fitness First (für Mitglieder kostenlos),
              Wassersportmöglichkeiten (Fremdanbieter), Telefon, Panorama A la Carte Restaurant, Teppanyaki A la Carte Restaurant, Pavillonservice am
              Strand, Mini Golf (mit Vorreservierung) und Kletterpark (mit Vorreservierung)
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <!-- AI vs UA Drinks Upgrade Section -->
      <div class="luxury-card-section drinks-info">
        <div class="text-center mb-8">
          <span class="gold-gradient-badge">PREMIUM UPGRADE</span>
          <h4 class="bar-headline-title mt-2">Upgrade von All-Inclusive zu <strong>Ultra All-Inclusive</strong></h4>
          <p class="bar-headline-subtitle">Profitiere von exklusiver Marken-Auswahl ohne Limitierungen für eventTeilnehmer</p>
        </div>

        <div class="ai-ua-comparison mb-8">
          <div class="comparison-card ai-card">
            <div class="comparison-card-header">
              <span class="badge">BISHER (ALL-INCLUSIVE)</span>
            </div>
            <div class="comparison-card-body">
              <p>
                <v-icon color="grey darken-1" class="mr-2" small>mdi-close-circle-outline</v-icon> Alle nicht alkoholischen Getränke
                <span class="exception">(Ausnahme: Energy Drink)</span>
              </p>
              <p>
                <v-icon color="grey darken-1" class="mr-2" small>mdi-close-circle-outline</v-icon> Alle lokalen alkoholischen Getränke
                <span class="exception">(Ausnahme: Weinsorten)</span>
              </p>
              <p>
                <v-icon color="grey darken-1" class="mr-2" small>mdi-close-circle-outline</v-icon> Frisch gepresster Orangensaft und Grapefruitsaft
                beim Frühstück
              </p>
            </div>
          </div>
          <div class="comparison-card-divider">
            <v-icon large color="primary">mdi-arrow-right-bold-circle-outline</v-icon>
          </div>
          <div class="comparison-card ua-card">
            <div class="comparison-card-header">
              <span class="badge gold-badge">NEU (ULTRA ALL-INCLUSIVE)</span>
            </div>
            <div class="comparison-card-body">
              <p class="highlight-text"><strong>Zusätzlich vollumfänglich inklusive:</strong></p>
              <p>
                <v-icon color="success" class="mr-2" small>mdi-check-circle-outline</v-icon> Alle Import Getränke
                <span class="exception">(Ausnahme: einige Premiumgetränke)</span>
              </p>
              <p><v-icon color="success" class="mr-2" small>mdi-check-circle-outline</v-icon> Sekt & Champagner</p>
              <p><v-icon color="success" class="mr-2" small>mdi-check-circle-outline</v-icon> Energy Drinks</p>
            </div>
          </div>
        </div>

        <!-- Brand Section Header -->
        <div class="brand-section-header text-center mb-8">
          <span class="section-pre-title">BAR-KARTE HIGHLIGHTS</span>
          <h4 class="section-main-title">Premium Marken-Auswahl (Ultra All-Inclusive)</h4>
          <div class="luxury-accent-line"></div>
        </div>

        <!-- Luxury Brand Cards Grid -->
        <v-row class="brand-cards-grid mb-8">
          <v-col cols="12" sm="6" md="4" lg="3" v-for="(category, index) in brandCategories" :key="index" class="pa-2">
            <div class="brand-category-card">
              <div class="brand-card-header">
                <div class="brand-icon-circle">
                  <v-icon color="primary" small>{{ category.icon }}</v-icon>
                </div>
                <span class="brand-category-title">{{ category.title }}</span>
              </div>
              <div class="brand-tags-container">
                <span class="luxury-brand-chip" v-for="(brand, bIndex) in category.brands" :key="bIndex">
                  {{ brand }}
                </span>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-6"></v-divider>

        <div class="fine-print-storno">
          <v-icon small color="grey darken-1" class="mr-2">mdi-shield-alert-outline</v-icon>
          <span
            ><strong>Stornierungsgarantie:</strong> Maximale Flexibilität. Stornierungen bis zu 90 Tage vor Reiseantritt sind absolut kostenfrei.
            Danach greifen die regulären Konditionen des Veranstalters.</span
          >
        </div>
      </div>

      <!-- Final Actions CTA Section -->
      <div class="final-actions">
        <v-btn class="book-now-btn" color="primary" x-large rounded dark @click="pushToBookingPage">
          <v-icon left>mdi-rocket-launch-outline</v-icon>
          JETZT PLATZ SICHERN
        </v-btn>
      </div>
    </div>

    <!-- Feedback Mechanism -->
    <v-snackbar v-model="snackbar" top centered color="rgb(20, 20, 20)" class="modern-toast" timeout="4000">
      <div class="d-flex align-center font-weight-bold">
        <v-icon color="amber" class="mr-3">mdi-information-outline</v-icon>
        <span>Du hast bereits eine aktive Buchung für dieses Event hinterlegt.</span>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import api from "../../api"
import { mapGetters, mapActions } from "vuex"

export default {
  name: "aliBey",
  data() {
    return {
      hasListEntry: false,
      snackbar: false,
      features: [
        { icon: "mdi-bed-king-outline", text: "7 Nächte im exklusiven Premium-Zimmer" },
        { icon: "mdi-car-connected", text: "Bequemer Transfer (Hotel/Flughafen)" },
        { icon: "mdi-glass-cocktail", text: "Premium Ultra All-Inclusive" },
        { icon: "mdi-weight-lifter", text: "Tägliche High-End Groupfitness-Kurse" },
        { icon: "mdi-ticket-confirmation-outline", text: "Wellcome Opening & Gala-Night" },
        { icon: "mdi-face-agent", text: "24/7 Support durch unser Team vor Ort" },
      ],
      brandCategories: [
        {
          title: "Bier",
          icon: "mdi-beer",
          brands: ["Heineken", "Becks", "Miller", "Bomonti"],
        },
        {
          title: "Wodka",
          icon: "mdi-glass-cocktail",
          brands: ["Absolut", "Smirnoff", "Ketel One"],
        },
        {
          title: "Whiskey",
          icon: "mdi-glass-wine",
          brands: [
            "Chivas Regal 12 Yrs",
            "Ballantine’s 12 Yrs",
            "Jack Daniels",
            "Jim Beam",
            "Johnnie Walker Black Label 12 Yrs",
            "Johnnie Walker Red Label",
            "The Glenlivet Founder’ Reserve",
          ],
        },
        {
          title: "Gin",
          icon: "mdi-glass-wine",
          brands: ["Beefeater", "Gordon’s London Dry"],
        },
        {
          title: "Rum",
          icon: "mdi-glass-cocktail",
          brands: ["Bacardi", "Havana Anejo 3 Anos", "Captain Morgan Black"],
        },
        {
          title: "Tequila",
          icon: "mdi-glass-cocktail",
          brands: ["Olmeca Gold", "El Jimador"],
        },
        {
          title: "Liquer",
          icon: "mdi-bottle-wine-outline",
          brands: ["Jagermeister", "Amaretto", "Malibu", "Baileys", "Frenet Branca", "Liquer 43", "Ramazotti"],
        },
        {
          title: "Digestive",
          icon: "mdi-glass-cocktail",
          brands: ["Campari", "Martini (Bianco, Rosso, Extra Dry)"],
        },
      ],
    }
  },
  created() {
    api.checkListEntry("alibey").then((data) => (this.hasListEntry = data))
    this.setNavigationBarText({ text: "RESERVATION", state: false, color: "alibey" })
  },
  computed: {
    ...mapGetters("navigationStoreNotPersisted", ["navigationBarTextState"]),
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText"]),
    openSunExpress() {
      window.open("https://sunexpress.com", "__blank")
    },
    openEdelweiss() {
      window.open("https://www.flyedelweiss.com/ch/de/home.html", "__blank")
    },
    pushToBookingPage() {
      this.$router.push({ name: "AliBeyBooking" })
      this.snackbar = true
    },
    scrollToContent() {
      this.$refs.contentSection.scrollIntoView({ behavior: "smooth" })
    },
  },
  watch: {
    async navigationBarTextState(value) {
      value && this.pushToBookingPage()
    },
  },
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");

.premium-event-page {
  background-color: #f8fafc;
  color: #0f172a;
  font-family: "Poppins", sans-serif;
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  letter-spacing: -0.2px;
  line-height: 1.6 !important;
}

/* Explicit line-height & margin resets for all text blocks to prevent squished layouts */
.premium-event-page h1,
.premium-event-page h2,
.premium-event-page h3,
.premium-event-page h4,
.premium-event-page h5,
.premium-event-page h6 {
  line-height: 1.35 !important;
  margin-bottom: 12px !important;
}

.premium-event-page p {
  line-height: 1.6 !important;
  margin-bottom: 12px !important;
}

/* Custom Minimal Floating Back Button */
.custom-back-btn {
  position: fixed;
  top: 24px;
  left: 24px;
  z-index: 150;
  background-color: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateX(-4px) scale(1.05);
    background-color: #ffffff !important;
  }
}

/* Luxury Hero Viewport Architecture */
.hero-viewport {
  position: relative;
  .hero-overlay {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0.85) 100%);
    padding: 24px;
  }
}

.glass-hero-card {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 32px;
  padding: 48px 32px;
  max-width: 700px;
  width: 100%;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  margin-bottom: 2rem;
}

.location-tag {
  font-size: 0.8rem;
  font-weight: 700;
  color: white;
  letter-spacing: 3px;
  color: var(--v-primary-base);
  text-transform: uppercase;
}

.main-event-title {
  font-weight: 900;
  font-size: 2.8rem;
  color: #ffffff;
  line-height: 1.2 !important;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: -1px;
}

.premium-date-wrapper {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 24px;
  border-radius: 50px;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 16px;
  margin-bottom: 24px;
}

.hero-teaser-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.05rem;
  line-height: 1.6 !important;
  font-weight: 400;
  margin-bottom: 32px;
}

.cta-pulse-button {
  height: 54px !important;
  padding: 0 36px !important;
  border-radius: 50px !important;
  letter-spacing: 1px !important;
  transition: all 0.3s ease !important;

  &:hover {
    transform: scale(1.03) translateY(-2px);
    box-shadow: 0 15px 30px rgba(255, 255, 255, 0.2) !important;
  }
}

/* Elegant Scroll Indicator */
.scroll-discover {
  position: absolute;
  bottom: 2.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  opacity: 0.6;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }
  .discover-text {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 2px;
    color: #ffffff;
  }
}

.mouse-icon {
  width: 22px;
  height: 36px;
  border: 2px solid #ffffff;
  border-radius: 12px;
  position: relative;
  .wheel {
    width: 4px;
    height: 8px;
    background-color: #ffffff;
    border-radius: 2px;
    position: absolute;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
    animation: scroll-anim 1.6s infinite;
  }
}

@keyframes scroll-anim {
  0% {
    opacity: 1;
    top: 6px;
  }
  100% {
    opacity: 0;
    top: 18px;
  }
}

/* Content Stream Wrapper */
.luxury-body-wrapper {
  margin-top: -5vh;
  padding: 0 24px 80px 24px;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  background-color: #f8fafc;
  position: relative;
  z-index: 20;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.luxury-card-section {
  background-color: #ffffff;
  border-radius: 32px;
  padding: 40px;
  margin-bottom: 32px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02), 0 20px 40px rgba(15, 23, 42, 0.03);
  border: 1px solid rgba(226, 232, 240, 0.8);

  &.alternative-bg {
    background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);
  }
}

/* Header UI Elements */
.section-header-block {
  .section-pre-title {
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--v-primary-base);
    letter-spacing: 2px;
  }
  .section-main-title {
    font-size: 1.75rem;
    font-weight: 850;
    color: #0f172a;
    letter-spacing: -0.5px;
    margin-top: 2px;
  }
  .luxury-accent-line {
    width: 40px;
    height: 4px;
    background-color: var(--v-primary-base);
    border-radius: 2px;
    margin: 12px auto 0 auto;
  }
}

/* Bento Box Grid Architecture */
.nested-bento-grid {
  margin: 0 -12px;
}

.bento-card {
  position: relative;
  border-radius: 24px;
  height: 100%;
  display: flex;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.01);

  &.text-card {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 24px;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;

    &:hover {
      background-color: #ffffff;
      border-color: var(--v-primary-base);
      box-shadow: 0 20px 30px rgba(15, 23, 42, 0.05);
      transform: translateY(-4px);
    }
  }

  .bento-icon-wrapper {
    background: rgba(var(--v-primary-base), 0.08);
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .bento-icon {
      font-size: 1.5rem !important;
    }
  }

  .bento-content {
    flex: 1;
    text-align: left;

    h4 {
      font-size: 1rem;
      font-weight: 800;
      line-height: 1.35 !important;
      color: #0f172a;
      margin-bottom: 6px !important;
    }

    .bento-subtext {
      font-size: 0.85rem;
      color: #64748b;
      margin-bottom: 0 !important;
      line-height: 1.5 !important;
    }
  }
}

/* Structural Pillars Section */
.premium-pillars-layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;

  .pillar-item {
    text-align: center;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .pillar-status-ring {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e2e8f0;

      .v-icon {
        font-size: 1.5rem !important;
      }
    }

    h4 {
      font-size: 1.1rem;
      font-weight: 750;
      color: #0f172a;
      margin-top: 16px !important;
      margin-bottom: 8px !important;
      line-height: 1.35 !important;
    }
    p {
      font-size: 0.9rem;
      color: #475569;
      line-height: 1.5 !important;
      margin-bottom: 0 !important;
    }
  }
}

/* Flight Section Travel Timeline */
.luxury-flight-card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.01);
  height: 100%;

  .flight-card-header {
    background-color: #f8fafc;
    padding: 16px 24px;
    border-bottom: 1px solid #e2e8f0;
  }

  .flight-direction-badge {
    display: inline-flex;
    align-items: center;
    font-size: 0.75rem;
    font-weight: 700;
    color: #475569;
    letter-spacing: 0.5px;
  }

  .flight-routes {
    padding: 24px;
  }
}

.flight-route-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px;
  border-radius: 12px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8fafc;

    .external-icon {
      color: var(--v-primary-base) !important;
      transform: translateX(2px);
    }
  }

  .airline-logo-box {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 140px;

    .airline-meta {
      display: flex;
      flex-direction: column;

      .airline-name {
        font-size: 0.9rem;
        font-weight: 750;
        color: #0f172a;
      }

      .flight-number {
        font-size: 0.7rem;
        color: #64748b;
        font-weight: 500;
      }
    }
  }

  .route-timeline {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: flex-end;
    padding: 0 16px;
  }

  .airport-node {
    display: flex;
    flex-direction: column;
    text-align: right;

    .node-time {
      font-size: 1rem;
      font-weight: 800;
      color: #0f172a;
    }

    .node-code {
      font-size: 0.75rem;
      color: #64748b;
      font-weight: 600;
    }
  }

  .external-icon {
    transition: all 0.2s ease;
  }
}

.flight-disclaimer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.5 !important;
  margin: 0 auto;
}

/* Accordion Upgrade */
.boutique-panels {
  .boutique-panel-item {
    background-color: #f8fafc !important;
    border-radius: 16px !important;
    margin-bottom: 12px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    &::before {
      box-shadow: none !important;
    }
  }
  .boutique-panel-trigger {
    padding: 20px 24px;
    font-size: 1rem;
    color: #1e293b;
    font-weight: 700;
  }
}

::v-deep .v-expansion-panel-content__wrap {
  background: #ffffff;
  border-top: 1px solid #edf2f7;
  padding: 20px 24px !important;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.65 !important;
}

/* AI vs UA Comparative Grid */
.ai-ua-comparison {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 20px;

  .comparison-card {
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.01);
    height: 100%;

    .comparison-card-header {
      background-color: #f8fafc;
      padding: 16px 24px;
      border-bottom: 1px solid #e2e8f0;
      text-align: center;

      .badge {
        font-size: 0.75rem;
        font-weight: 750;
        color: #475569;
        letter-spacing: 0.5px;

        &.gold-badge {
          color: var(--v-primary-base);
        }
      }
    }

    .comparison-card-body {
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      p {
        font-size: 0.88rem;
        color: #334155;
        margin-bottom: 0 !important;
        line-height: 1.55 !important;
        display: flex;
        flex-direction: column;
      }

      .exception {
        font-size: 0.78rem;
        color: #64748b;
        display: block;
        margin-top: 2px;
        line-height: 1.35 !important;
      }

      .highlight-text {
        font-size: 0.95rem;
        color: #0f172a;
        margin-bottom: 4px !important;
      }
    }
  }

  .comparison-card-divider {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* Brand menu shelf layout */
.premium-bar-shelf {
  .gold-gradient-badge {
    background: linear-gradient(90deg, var(--v-primary-base), #ffaa00);
    color: white;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 4px 14px;
    border-radius: 50px;
    letter-spacing: 1px;
  }
  .bar-headline-title {
    font-size: 1.35rem;
    font-weight: 800;
    color: #0f172a;
  }
  .bar-headline-subtitle {
    font-size: 0.9rem;
    color: #64748b;
    max-width: 600px;
    margin: 0 auto;
  }
}

/* Brand Section Header */
.brand-section-header {
  margin-top: 40px;

  .section-pre-title {
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--v-primary-base);
    letter-spacing: 2px;
  }
  .section-main-title {
    font-size: 1.45rem;
    font-weight: 850;
    color: #0f172a;
    letter-spacing: -0.5px;
    margin-top: 2px;
  }
  .luxury-accent-line {
    width: 40px;
    height: 4px;
    background-color: var(--v-primary-base);
    border-radius: 2px;
    margin: 12px auto 0 auto;
  }
}

/* Brand Grid Cards */
.brand-cards-grid {
  margin: 0 -8px;
}

.brand-category-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.01);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: var(--v-primary-base);
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(15, 23, 42, 0.04);
  }
}

.brand-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #e2e8f0;
  padding-bottom: 8px;
}

.brand-icon-circle {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: rgba(var(--v-primary-base), 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .v-icon {
    font-size: 0.9rem !important;
  }
}

.brand-category-title {
  font-weight: 800;
  font-size: 0.78rem;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.brand-tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1;
  align-content: flex-start;
}

.luxury-brand-chip {
  display: inline-block;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 4px 10px;
  border-radius: 50px;
  font-size: 0.72rem;
  font-weight: 500;
  color: #475569;
  transition: all 0.2s ease;

  &:hover {
    background: #ffffff;
    border-color: var(--v-primary-base);
    color: var(--v-primary-base);
  }
}

.fine-print-storno {
  display: flex;
  align-items: flex-start;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.55 !important;
  margin: 0 auto;

  .v-icon {
    margin-top: 2px;
  }
}

/* Bottom CTA block */
.final-actions {
  text-align: center;
  margin-top: 24px;
  padding: 24px 0 0 0;
}

.book-now-btn {
  height: 60px !important;
  padding: 0 48px !important;
  font-size: 1.05rem !important;
  font-weight: 850 !important;
  letter-spacing: 0.5px !important;
  border-radius: 50px !important;
  animation: dynamic-glow 3s infinite;
}

@keyframes dynamic-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 10px 25px rgba(var(--v-primary-base), 0.3);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 15px 35px rgba(var(--v-primary-base), 0.55);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 10px 25px rgba(var(--v-primary-base), 0.3);
  }
}

.modern-toast {
  border-radius: 16px !important;
}

/* Complex UI Animations */
.animate-blur-in {
  animation: blurIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes blurIn {
  from {
    opacity: 0;
    transform: translateY(20px);
    filter: blur(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

/* Responsiveness Tuning */
@media (max-width: 960px) {
  .main-event-title {
    font-size: 2.1rem;
  }
  .glass-hero-card {
    padding: 32px 16px;
    border-radius: 24px;
  }
  .luxury-card-section {
    padding: 24px 16px;
    border-radius: 24px;
  }
  .bento-card.text-card {
    padding: 16px;
    gap: 12px;
  }
  .ai-ua-comparison {
    grid-template-columns: 1fr;
    gap: 20px;

    .comparison-card-divider {
      transform: rotate(90deg);
      padding: 10px 0;
      margin: 0 auto;
    }
  }
  .flight-route-item {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    .route-timeline {
      padding: 0;
      justify-content: flex-start;
    }
  }
}

/* Specific Mobile Layout Tuning */
@media (max-width: 600px) {
  .hero-viewport {
    height: auto !important;
  }
  .hero-overlay {
    height: auto !important;
    min-height: 95vh;
    padding: 16px !important;
    padding-top: 64px !important;
    padding-bottom: 40px !important;
  }
  .glass-hero-card {
    padding: 24px 16px !important;
    margin-bottom: 1rem !important;
    border-radius: 24px !important;
  }
  .main-event-title {
    font-size: 1.6rem !important;
    line-height: 1.25 !important;
    letter-spacing: -0.5px !important;
    margin-top: 4px !important;
    margin-bottom: 12px !important;
  }
  .premium-date-wrapper {
    padding: 6px 16px !important;
    font-size: 0.8rem !important;
    margin-top: 8px !important;
    margin-bottom: 16px !important;
  }
  .hero-teaser-text {
    font-size: 0.88rem !important;
    line-height: 1.5 !important;
    margin-bottom: 20px !important;
  }
  .cta-pulse-button {
    height: 46px !important;
    padding: 0 24px !important;
    font-size: 0.85rem !important;
  }
  .scroll-discover {
    display: none !important;
  }
  .custom-back-btn {
    top: 16px !important;
    left: 16px !important;
  }
}
</style>
